/**
 * Gets the start index of the first breadcrumb which can be shown, given the
 * width of the window.
 * @param xPos The starting x-position.
 * @param widths The widths of the children of the breadcrumbs wrapper.
 * @param maxWidth The maximum allowed width of the breadcrumbs wrapper.
 * @returns
 */
export const getStartIdx = (
	xPos: number,
	widths: number[],
	maxWidth: number,
): number => {
	let width = xPos;
	for (let i = widths.length - 1; i >= 0; i--) {
		if (width + widths[i]! > maxWidth) {
			return i + 1;
		}

		width += widths[i]!;
	}

	return 0;
};
